import * as React from "react";
import { GeneralModal } from "../Common/GeneralModal/GeneralModal";
import { AirWallexNewTransfer } from "./Steps/Step1";
import { ConfirmDetails } from "./Steps/Step2";
import { SuccessStep } from "./Steps/SuccessStep";
import { ScaVerify } from "../ScaAirwallex/ScaVerify";
import { ErrorStep } from "./Steps/ErrorStep";
import { addRecipientApi } from "../../api/api";
import { useLoader } from "../Common/GeneralLoader/GeneralLoaderProvider";

export function AddRecipientFlow() {
  const [step, setStep] = React.useState(1);
  const [open, setOpen] = React.useState(true);
  const [showCloseIcon, setShowCloseIcon] = React.useState(true);
  const [payload, setPayload] = React.useState({});
  const { showLoader, hideLoader } = useLoader();

  React.useEffect(() => {
    jQuery(".add-recipient-popup select").each(function (index, element) {
      const $select = jQuery(element);
      const $parent = $select.closest(".form--item");

      $select.select2({
        dropdownAutoWidth: true,
        dropdownParent: $parent,
        minimumResultsForSearch: Infinity,
        scrollAfterSelect: true,
      });
    });

    if (step == 5) {
      setShowCloseIcon(false);
    }
  }, [step]);

  const getStepComponent = (step) => {
    switch (step) {
      case -1:
        return <ErrorStep />;
      case 0:
        return <SuccessStep setStep={setStep} />;
      case 1:
        return <AirWallexNewTransfer setStep={setStep} payload={payload} setPayload={setPayload} />;
      case 2.0:
        // Always show confirm details; on Submit, API may return 403 → step 2.1 (SCA)
        return (
          <ConfirmDetails setStep={setStep} payload={payload} setPayload={setPayload} />
        );
      case 2.1:
        // SCA step after 403 from create beneficiary API; on success retry API with token
        return (
          <ScaVerify
            key={2.1}
            scaSessionCode={payload?.scaSessionCode}
            setStep={setStep}
            payload={payload}
            setPayload={setPayload}
            onCancel={() => setOpen(false)}
            onVerificationSucceed={async (result) => {
              const requestPayload = payload?._addRecipientRequest;
              if (!requestPayload || !result?.token) {
                setStep(-1);
                return;
              }
              showLoader();
              try {
                const response = await addRecipientApi(requestPayload, {
                  scaToken: result.token,
                });
                if (response?.result) {
                  jQuery(".view-bank-recipient").trigger("RefreshView");
                  setStep(0);
                } else {
                  setStep(-1);
                }
              } catch {
                setStep(-1);
              } finally {
                hideLoader();
              }
            }}
            onVerificationFailed={() => setStep(-1)}
          />
        );
      case 3:
        return <ConfirmDetails setStep={setStep} payload={payload} setPayload={setPayload} />;
    }
  };

  return (
    <GeneralModal
      open={open}
      setOpen={setOpen}
      showCloseIcon={showCloseIcon}
      className={
        step == 0
          ? `add-recipient-popup has-success`
          : step == -1
            ? "add-recipient-popup has-error"
            : `add-recipient-popup step-${step}`
      }
    >
      {getStepComponent(step)}
    </GeneralModal>
  );
}
